import Widget from "@/components/widgets";
import type { WidgetConfig } from "@/types";
import { CollectionFormComponentWidget } from "@/features/collection-form/pages";

declare global {
  interface Window {
    CollectionFormWidget: typeof CollectionFormWidget;
  }
}

class CollectionFormWidget extends Widget {
  static init(config: WidgetConfig) {
    return super.init(config, CollectionFormComponentWidget);
  }
}

if (typeof window !== "undefined") {
  window.CollectionFormWidget = CollectionFormWidget;
}

export default CollectionFormWidget;
